// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__IVbev","loading":"skeleton_loading__A1D1V"};